<div
    [class.bazis-modal]="!modal().options.styleAlert"
    [ngClass]="[
        modal().options.cssClass,
        isScrollingContent ? 'bazis-modal--scrolling' : '',
        modal().options.modalType === 'fullscreen' ? 'bazis-container' : '',
        modal().options.modalType,
    ]"
>
    @if (modal().options.hasCloseIcon) {
        <bazis-button
            fill="clear"
            class="bazis-modal__close"
            (click)="close()"
        >
            <bazis-icon
                name="cross"
                slot="icon-only"
            ></bazis-icon>
            <!-- <bazis-icon class="bh-hide-sm-up" name="arrow-left" slot="icon-only"></bazis-icon> -->
        </bazis-button>
    }
    <ng-template #componentHost></ng-template>
</div>

@if (modal().options.hasBackdrop) {
    <div
        class="bazis-backdrop"
        (click)="closeFromBackdrop()"
    ></div>
}
